<template>
	<div class="childDiv1 bg-[#beb8b4]" id="page2" ref="mainEl" page="2">
		<img src="images/1x_images/section1/page2/page2-img.png" srcset="images/2x_images/section1/page2/page2-img.png 2x" class="img-bg" />
		<div class="relative childWrapper">
			<div class="relative" ref="wrapEl">
				<img alt="" src="images/1x_images/section1/page2/page2-title.png" srcset="images/2x_images/section1/page2/page2-title.png 2x" class="absolute top-[162px] center z-[3]" ref="titleEl" />
				<img alt="" src="images/1x_images/section1/page2/page2-img.png" srcset="images/2x_images/section1/page2/page2-img.png 2x" class="absolute top-[-360px] z-[2]" ref="imageEl" />
				<img alt="" src="images/1x_images/section1/page2/page2-text1.png" srcset="images/2x_images/section1/page2/page2-text1.png 2x" class="absolute z-[3] top-[860px] left-[225px]" ref="text1El" :style="{ filter: `blur(${textBlur1}px)` }" />
				<img alt="" src="images/1x_images/section1/page2/page2-text2.png" srcset="images/2x_images/section1/page2/page2-text2.png 2x" class="absolute z-[3] top-[950px] left-[175px]" ref="text2El" :style="{ filter: `blur(${textBlur2}px)` }" />
				<img alt="" src="images/1x_images/section1/page2/page2-text3.png" srcset="images/2x_images/section1/page2/page2-text3.png 2x" class="absolute z-[3] top-[1035px] left-[265px]" ref="text3El" :style="{ filter: `blur(${textBlur3}px)` }" />
				<img alt="" src="images/1x_images/section1/page2/page2-text4.png" srcset="images/2x_images/section1/page2/page2-text4.png 2x" class="absolute z-[3] top-[1135px] left-[568px]" ref="text4El" />
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";

export default {
	name: "page-2",
	data() {
		return {
			stopped: true,
			textBlur1: 7,
			textBlur2: 7,
			textBlur3: 7,
		};
	},
	methods: {
		start() {
			console.log("start page 2");
			this.context.add(() => {
				gsap.to(this.$refs.titleEl, { y: 0, force3D: true, ease: "expo.inOut", duration: 2.3 });
				gsap.to(this.$refs.imageEl, { y: 0, force3D: true, ease: "expo.inOut", duration: 2.3 });
				gsap.to(this.$refs.text1El, { x: 0, force3D: true, autoAlpha: 1, duration: 1, delay: 1.2 });
				gsap.to(this.$refs.text2El, { x: 0, force3D: true, autoAlpha: 1, duration: 1, delay: 1.7 });
				gsap.to(this.$refs.text3El, { x: 0, force3D: true, autoAlpha: 1, duration: 1, delay: 2.2 });
				gsap.to(this.$refs.text4El, { x: 0, force3D: true, autoAlpha: 1, duration: 1, delay: 2.7 });
				// text blur
				gsap.to(this, { textBlur1: 0, duration: 1, delay: 1 });
				gsap.to(this, { textBlur2: 0, duration: 1, delay: 1.5 });
				gsap.to(this, { textBlur3: 0, duration: 1, delay: 2 });
			});
		},
		stop() {
			console.log("stop page 2");
			if (this.context) this.context.revert();
			// this.reset();
		},
		reset() {
			console.log("page 2 reset", this);
			gsap.set(this.$refs.titleEl, { y: 250, overwrite: true });
			gsap.set(this.$refs.imageEl, { y: 325, overwrite: true });
			gsap.set(this.$refs.text1El, { x: -50, autoAlpha: 0, overwrite: true });
			gsap.set(this.$refs.text2El, { x: -50, autoAlpha: 0, overwrite: true });
			gsap.set(this.$refs.text3El, { x: -50, autoAlpha: 0, overwrite: true });
			gsap.set(this.$refs.text4El, { x: -50, autoAlpha: 0, overwrite: true });
		},
	},
	mounted() {
		this.reset();
		gsap.set(this.$refs.wrapEl, { top: aspectRatio < 0.74 ? 0 : "25px" });
		this.context = gsap.context(() => {}, this.$el); // Scope to the component's root element
	},
};
</script>

<style></style>
